/**
 * Find Account API
 *
 * @author minkyoung.park@emcast.com
*/
import httpService from '@/api/httpService'

// const BRAND_CODE = localStorage.getItem('brandCode')
const findApi = {

    // 외부인증 사용(get external auth use)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-guest-find-info
    externalFind(params) {
        return httpService.get(`/guest/${BRAND_CODE}/find`, params)
    },

    // 정보로 계정 찾기(Find an account with information)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-guest-find-by-info
    findByInfo(params) {
        return httpService.get(`/guest/${BRAND_CODE}/find/by/info`, params)
    },
    
    // 아이디 찾기 요청(Request to find account ID)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-guest-find-id
    requestFindId(params) {
        return httpService.post(`/guest/${BRAND_CODE}/find/id/request`, params)
    },

    // 아이디 찾기(Find account ID)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-guest-find-id-confirm
    findId(params) {
        return httpService.put(`/guest/${BRAND_CODE}/find/id`, params)
    },

    // 비밀번호 변경 요청(Request password change)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-guest-change-pw
    requestFindPw(params) {
        return httpService.post(`/guest/${BRAND_CODE}/find/pw/request`, params)
    },

    // 비밀번호 변경 확인(Confirm password change)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-guest-change-pw-check
    checkFindPw(params) {
        return httpService.put(`/guest/${BRAND_CODE}/find/pw/check`, params)
    },

    // 비밀번호 변경 수정(Modify password change)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-guest-change-pw-change
    changeFindPw(params) {
        return httpService.put(`/guest/${BRAND_CODE}/find/pw/change `, params)
    },

}

// export const 
export default findApi